import {useCallback, useContext} from 'react';

import {Channels, Plugins} from '..';
import {useBranding} from '../../branding/Context';
import type {PluginElements} from '../types';

export const useOrderedPlugins = (): PluginElements[] => {
    const pluginManifest = useBranding('plugins');
    const plugins = useContext(Plugins);
    const channelsRef = useContext(Channels);

    /**
     * Finds the ids of all channels for a particular plugin ID, including its widgets channels
     */
    const findPluginChannelsIds = useCallback(
        (pluginId: string) => {
            if (!channelsRef?.current) {
                return [];
            }
            return Array.from(channelsRef.current.keys()).filter(
                channelId =>
                    channelId.startsWith(`${pluginId}-`) ||
                    channelId.startsWith(`${pluginId}:widget-`),
            );
        },
        [channelsRef],
    );

    return pluginManifest?.every(plugin => plugin.id)
        ? pluginManifest.flatMap(plugin => {
              const channelIds = plugin.id
                  ? findPluginChannelsIds(plugin.id)
                  : [];
              return channelIds.flatMap<PluginElements>(channelId => {
                  const UIelements = plugins[channelId];
                  return UIelements ? [UIelements] : [];
              });
          })
        : Object.values(plugins);
};
